import React, { useMemo, useRef, useState } from "react";
import { motion } from "framer-motion";
import { useOnClickOutside } from "usehooks-ts";
import { EMOJI_CATEGORIES, EMOJI_CATEGORIES_LIST, EMOJI_LIST_BY_CATEGORIES, KEYWORDS_MAP_BY_CATEGORIES } from "../../../constants/components/emoji";
import EmojiList from "./EmojiList";
import EmojiCategoriesList from "./EmojiCategoriesList";
import { CSearch } from "../../UI";

import "./style.scss";

const EmojiPicker = ({isOpened, onSelect, onClose}) => {
    const [searchValue, setSearchValue] = useState('');
    const [activeCategory, setActiveCategory] = useState(EMOJI_CATEGORIES.SMILEYS_AND_PEOPLE);
    const containerRef = useRef(null);

    const emojiPickerConfig = useMemo(() => {
        return {
            visibility: 'visible',
            opacity: isOpened ? 1 : 0,
            transform: `translateY(${isOpened ? 0 : 10}px)`,
            transitionEnd: {
                visibility: isOpened ? 'visible' : 'hidden',
            }
        };
    }, [isOpened]);

    const filteredEmoji = useMemo(() => {
        return Object.entries(KEYWORDS_MAP_BY_CATEGORIES).reduce((obj, category) => {
            const [key, values] = category;
            let result = [];

            Object.entries(values).forEach(([key, value]) => {
                if (key.toLowerCase().includes(searchValue.toLowerCase()) || !searchValue) {
                    result.push(value);
                }
            });

            obj[key] = [...new Set(result.flat())];

            return obj;
        }, {});
    }, [searchValue]);

    useOnClickOutside(containerRef, onClose);

    function handleSelectCategory(category) {
        setActiveCategory(category);

        const childElement = document.querySelector(`[data-emoji-category="${category}"]`);
        const parentContainer = document.querySelector('.emoji-picker-smileys');

        if (!childElement || !parentContainer) {
            return;
        }

        parentContainer.scrollTo({
            top: childElement.offsetTop - (parentContainer.offsetTop - 45), // 45 - paadding и margin элементов
            behavior: 'smooth',
        });
    }

    return (
        <motion.div
            key="EmojiPicker"
            ref={containerRef}
            animate={emojiPickerConfig}
            initial={emojiPickerConfig}
            transition={{
                ease: 'linear',
                duration: .3,
            }}
            className="emoji-picker"
        >
            <CSearch
                value={searchValue}
                isActive={isOpened}
                hasButton={false}
                onSearch={setSearchValue}
            />
            <EmojiList
                emojiList={EMOJI_LIST_BY_CATEGORIES}
                filteredEmoji={filteredEmoji}
                onSelectEmoji={onSelect}
                onChangeCategory={setActiveCategory}
            />
            <EmojiCategoriesList
                categories={EMOJI_CATEGORIES_LIST}
                filteredEmoji={filteredEmoji}
                activeCategory={activeCategory}
                onSelectCategory={handleSelectCategory}
            />
        </motion.div>
    );
};

export default EmojiPicker;
